/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import getEnvironment from '../../../utils/getEnvironment';

const apiKey =
  getEnvironment() === 'production'
    ? process.env.REACT_APP_GOOGLE_MAP_API_KEY_PROD
    : getEnvironment() === 'test'
    ? process.env.REACT_APP_GOOGLE_MAP_API_KEY_TEST
    : process.env.REACT_APP_GOOGLE_MAP_API_KEY_DEV;

const eventsMapping = {
  onCenterChanged: ['center_changed', (map) => map.getCenter()],
  onBoundsChangerd: ['bounds_changed', (map) => map.getBounds()],
};

export default function useGoogleMap({ zoom, center, events }) {
  const [mapState, setMapState] = useState({ loading: true });
  const mapRef = useRef();
  useEffect(() => {
    GoogleMapsApiLoader({ apiKey }).then((google) => {
      const map = new google.maps.Map(mapRef.current, {
        zoom,
        center,
        minZoom: zoom - 2,
        fullscreenControl: true,
        gestureHandling: 'cooperative',
      });
      Object.keys(events).forEach((eventName) =>
        map.addListener(eventsMapping[eventName][0], () =>
          events[eventName](eventsMapping[eventName][1](map)),
        ),
      );

      setMapState({ maps: google.maps, map, loading: false });
    });
  }, []);
  return { mapRef, ...mapState };
}
